import { ConfigProvider } from '@ecdlink/core';
import ReactDOM from 'react-dom';
import ConfigWrapper from './app/config-wrapper';
import './app/i18n';
// Generated by `yarn tailwind:build` from styles.css. Edit styles.css, never this file.
import './styles.generated.css';

ReactDOM.render(
  <ConfigProvider
    config={{
      authApi: process.env.REACT_APP_API || '',
      graphQlApi: process.env.REACT_APP_GRAPHQLAPI || '',
      themeUrl: process.env.REACT_APP_THEME || '',
      configUrl: process.env.REACT_REMOTE_CONFIG_URL || '',
    }}
  >
    <ConfigWrapper />
  </ConfigProvider>,
  document.getElementById('root')
);
